import React from "react";

export default function AircraftAnimation({ opacity = 0.09 }) {
  return (
    <div
      aria-hidden="true"
      className="fixed pointer-events-none select-none z-0 hidden sm:block"
      style={{ top: "26%", left: 0, width: "100%", overflow: "hidden" }}
    >
      {/*
        The animation keyframe (aircraftFly) is defined in index.css,
        guaranteeing it is always in the CSS bundle.
        Hidden on mobile (sm:block) to avoid overlapping the hero heading.
      */}
      <div
        style={{
          animation: "aircraftFly 30s linear infinite",
          display: "inline-block",
          opacity,
        }}
      >
        {/* Top-view commercial aircraft silhouette */}
        <svg
          viewBox="0 0 220 88"
          width="220"
          height="88"
          xmlns="http://www.w3.org/2000/svg"
          style={{ filter: "drop-shadow(0 0 10px rgba(0,212,255,0.35))" }}
          aria-hidden="true"
        >
          {/* ── Fuselage ── */}
          <ellipse cx="110" cy="44" rx="96" ry="10" fill="#b8d0e0" />
          <ellipse cx="110" cy="44" rx="95" ry="8.5" fill="#cce0ec" />
          {/* Nose section */}
          <ellipse cx="200" cy="44" rx="16" ry="7" fill="#ddeef7" />

          {/* ── Main wings (swept back) ── */}
          <path
            d="M 145,44 L 88,8 L 82,15 L 118,44 L 82,73 L 88,80 Z"
            fill="#8ab4c8"
          />
          {/* Wing root shading */}
          <path
            d="M 138,44 L 100,20 L 95,25 L 120,44 L 95,63 L 100,68 Z"
            fill="#9fc4d4"
            opacity="0.6"
          />
          {/* Flap detail lines */}
          <line x1="118" y1="22" x2="88" y2="12" stroke="rgba(0,212,255,0.45)" strokeWidth="0.8" />
          <line x1="118" y1="66" x2="88" y2="76" stroke="rgba(0,212,255,0.45)" strokeWidth="0.8" />

          {/* ── Engine pods ── */}
          <ellipse cx="105" cy="27" rx="17" ry="6" fill="#608aa4" />
          <ellipse cx="105" cy="27" rx="15" ry="4.5" fill="#9fc4d4" />
          <ellipse cx="105" cy="61" rx="17" ry="6" fill="#608aa4" />
          <ellipse cx="105" cy="61" rx="15" ry="4.5" fill="#9fc4d4" />

          {/* Engine intake glow */}
          <ellipse cx="90" cy="27" rx="4" ry="4" fill="rgba(0,212,255,0.55)" />
          <ellipse cx="90" cy="61" rx="4" ry="4" fill="rgba(0,212,255,0.55)" />

          {/* ── Horizontal stabilisers ── */}
          <path
            d="M 28,44 L 7,30 L 5,34 L 22,44 L 5,54 L 7,58 Z"
            fill="#8ab4c8"
          />

          {/* ── Vertical tail fin ── */}
          <path d="M 22,44 L 15,44 L 10,23 L 26,30 Z" fill="#9fc4d4" />

          {/* ── Fuselage window strip ── */}
          <rect x="78" y="41" width="100" height="6" rx="3" fill="rgba(0,212,255,0.12)" />
          {[88, 98, 108, 118, 128, 138, 148, 158, 168].map((x) => (
            <rect
              key={x}
              x={x}
              y={42.5}
              width="4"
              height="3"
              rx="1"
              fill="rgba(0,212,255,0.5)"
            />
          ))}

          {/* ── Contrail ── */}
          <line
            x1="18"
            y1="44"
            x2="-70"
            y2="44"
            stroke="rgba(255,255,255,0.15)"
            strokeWidth="6"
            strokeLinecap="round"
          />
          <line
            x1="18"
            y1="44"
            x2="-140"
            y2="44"
            stroke="rgba(255,255,255,0.06)"
            strokeWidth="11"
            strokeLinecap="round"
          />
          {/* Engine contrails */}
          <line
            x1="90"
            y1="27"
            x2="-60"
            y2="27"
            stroke="rgba(255,255,255,0.08)"
            strokeWidth="3"
            strokeLinecap="round"
          />
          <line
            x1="90"
            y1="61"
            x2="-60"
            y2="61"
            stroke="rgba(255,255,255,0.08)"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </div>
  );
}
